import usePostData from '../../../../../hooks/postHook';

export const useAddPhotos = ({ id }) => {
  const [{ body, isLoading, isError, error }, addPhotos] = usePostData(
    `office_case/${id}/photos`
  );

  return { body, isLoading, isError, error, addPhotos };
};
